<template>
  <div class="material-selector">
    <!-- 素材库选择 -->
    <div class="album-selector">
      <el-select
        v-model="currentAlbumId"
        placeholder="请选择素材库"
        @change="fetchMaterials"
        class="album-select"
      >
        <el-option
          v-for="album in albumList"
          :key="album.id"
          :label="album.name"
          :value="album.id"
        />
      </el-select>
    </div>

    <!-- 素材列表 -->
    <div class="material-list" v-if="materialList.length>0">
      <div
        v-for="item in materialList"
        :key="item.id"
        class="material-item"
        :class="{ selected: selectedId === item.id }"
        @click="selectMaterial(item)"
      >
        <div class="material-thumbnail">
          <video
            v-if="item.albumType=='Video'"
            :src="item.photoPath"
            :controls="true"
            class="thumbnail-media"
          ></video>
          <img
            v-else
            :src="item.photoPath ? item.photoPath : defineImg"
            alt="素材预览"
            class="thumbnail-media"
          />
        </div>
        <div class="material-name">{{ item.name }}</div>
      </div>
    </div>

    <div v-else>
      <el-empty/>
    </div>

    <!-- 操作按钮 -->
    <div class="action-buttons">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button
        type="primary"
        @click="handleConfirm"
        :disabled="!selectedId"
      >
        确认选择
      </el-button>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  props: {
    value: Object, // 用于v-model绑定
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      albumList: [],
      currentAlbumId: null,
      materialList: [],
      selectedId: null,
      selectedMaterial: null
    }
  },
  created() {
    this.fetchAlbumList()
  },
  methods: {
    // 获取素材库列表
    fetchAlbumList() {
      api.album.getAllAlbums({
        skipCount: 0,
        maxResultCount: 65535
      }).then(response => {
        this.albumList = response.items
        if (this.albumList.length > 0) {
          this.currentAlbumId = this.albumList[0].id
          this.fetchMaterials()
        }
      })
    },

    // 获取素材列表（无分页）
    fetchMaterials() {
      api.album.getAllPhotos({
        albumId: this.currentAlbumId,
        skipCount: 0,
        maxResultCount: 65535,
        albumType:this.type// 获取全部
      }).then(response => {
        this.materialList = response.items
        this.selectedId = null // 切换素材库时清空选择
        this.selectedMaterial = null
      })
    },

    // 选择素材
    selectMaterial(item) {
      this.selectedId = item.id
      this.selectedMaterial = item
    },

    // 确认选择
    handleConfirm() {
      if (!this.selectedId) {
        this.$message.warning('请选择一个素材')
        return
      }

      this.$emit('input', this.selectedMaterial) // 更新v-model
      this.$emit('confirm', this.selectedMaterial)
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.material-selector {
  display: flex;
  flex-direction: column;
  height: 60vh;
}

.album-selector {
  margin-bottom: 20px;
}

.album-select {
  width: 100%;
}

.material-list {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
  padding: 5px;
}

.material-item {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.material-item:hover {
  border-color: #409eff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.material-item.selected {
  border-color: #409eff;
  background-color: #f0f7ff;
}
.material-thumbnail {
  width: 100%;
  height: 160px; /* 统一高度 */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #f5f5f5;
  border-radius: 4px;
}

.thumbnail-media {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持宽高比填充容器 */
}

.choice-item-video {
  background: #000; /* 视频背景设为黑色 */
}

.material-name {
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.action-buttons {
  margin-top: 20px;
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}
</style>
